export enum NotificationType {
  MENTION = 'MENTION',
  FAILED_SAVE_SEND_MAIL_JOB = 'FAILED_SAVE_SEND_MAIL_JOB',
  APPROVAL_EVENT = 'APPROVAL_EVENT',
  STOPWATCH = 'STOPWATCH',
}
